var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{attrs:{"height":"80px"}},[_c('Header')],1),_c('el-container',{directives:[{name:"bar",rawName:"v-bar"}]},[_c('div',{staticClass:"vuebar-content"},[_c('el-main',[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }